/**
 * Client-side session event cache backed by localStorage.
 *
 * Stores non-pending and pending messages separately so that the last
 * non-pending message ID can be used as the SSE ``?last=`` parameter
 * for incremental loading.  Pending messages are volatile and are
 * always re-fetched from the gateway on reload; they are never used
 * as the ``last`` anchor.
 *
 * Each session gets its own key: ``talos_events_{sessionID}``.
 * The stored value is a JSON object:
 *
 *   { messages: [...], pendingMessages: [...], lastID: "msg_N" }
 */

export const MAX_CACHED = 100;

export function loadCache(sessionID) {
  try {
    const raw = localStorage.getItem(`talos_events_${sessionID}`);
    if (!raw) return { messages: [], pendingMessages: [], lastID: null };
    const data = JSON.parse(raw);
    return {
      messages: data.messages || [],
      pendingMessages: data.pendingMessages || [],
      lastID: data.lastID || null,
    };
  } catch {
    return { messages: [], pendingMessages: [], lastID: null };
  }
}

export function saveCache(sessionID, messages, pendingMessages) {
  // Keep only the last MAX_CACHED non-pending messages.
  const trimmed = (messages || []).slice(-MAX_CACHED);
  const lastID = trimmed.length > 0 ? trimmed[trimmed.length - 1].id : null;
  try {
    localStorage.setItem(`talos_events_${sessionID}`, JSON.stringify({
      messages: trimmed,
      pendingMessages: pendingMessages || [],
      lastID,
    }));
  } catch {
    // Storage full — silently ignore.
  }
}
